import { render, staticRenderFns } from "./receiveCoupon.vue?vue&type=template&id=79cb2484&scoped=true&"
import script from "./receiveCoupon.vue?vue&type=script&lang=js&"
export * from "./receiveCoupon.vue?vue&type=script&lang=js&"
import style0 from "./receiveCoupon.vue?vue&type=style&index=0&id=79cb2484&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb2484",
  null
  
)

export default component.exports